import {
	createContext,
	useContext,
	type Dispatch,
	type SetStateAction,
} from 'react';

export interface DialogSecureNotesContextValue {
	closeDialog: () => void;
	setUnlockedId: Dispatch<SetStateAction<number | null>>;
	unlockedId: number | null;
}

const dialogSecureNotesContext =
	createContext<DialogSecureNotesContextValue | null>(null);

export const useDialogSecureNotesContext = () => {
	const context = useContext(dialogSecureNotesContext);
	if (!context) {
		throw new Error(
			'useDialogSecureNotesContext must be used within a DialogSecureNotesProvider',
		);
	}
	return context;
};

export default dialogSecureNotesContext;
